<template>
  <landing-page
    chamber="president"
    chamberTitle="President"
    :loading="loading"
    :models="presidentModels"
    :currentModel="presidentModel"
    :landingModels="presidentLandingModels">
    <span slot="page-title">2020 Presidential Election Model</span>
  </landing-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { LandingPage } from '@/components'

const name = 'president_landing'

const components = {
  LandingPage
}

const computed = {
  ...mapGetters({
    models: 'aggregateModels/list',
    presidentLandingModels: 'landingModels/presidentList',
  }),
  currentDate () {
    return this.$store.getters['aggregateModels/currentDate']('president')
  },
  presidentModels () {
    return this.models.filter(model => model.chamber === 'PRESIDENT')
  },
  presidentModel () {
    return this.presidentModels.find(model => model.date === this.currentDate)
  }
}

const methods = {
  ...mapActions({
    getPresidentLandingModels: 'landingModels/presidentList'
  })
}

export default {
  name,
  components,
  computed,
  methods,
  data: () => ({
    loading: false
  }),
  beforeMount () {
    this.loading = true

    const params = {
      date: this.currentDate,
      // latest: true,
      chamber: 'President'
    }

    const promises = [
      this.getPresidentLandingModels({
        params,
        key: 'president'
      })
    ]

    Promise.all(promises).then(() => {
      this.loading = false
    })
  },
  // TODO: get updated meta text
  metaInfo: {
    title: 'President',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'Senate'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'Senate'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2020 U.S. election predictions for President, Senate and House Congressional elections. Includes model-driven predictions for key President, Senate and House races, polling and district information, and model simulations updated daily.'
      }
    ]
  }
}
</script>
